import { Routes, Route, Navigate } from 'react-router-dom'
import AdminLayout from './components/admin/AdminLayout'
import FormList from './components/admin/FormList'
import FormBuilderPage from './pages/FormBuilderPage'
import SubmissionsPage from './pages/SubmissionsPage'
import PublicFormPage from './pages/PublicFormPage'
import PublicResultsPage from './pages/PublicResultsPage'

export default function App() {
  return (
    <Routes>
      {/* Admin routes */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<FormList />} />
        <Route path="builder/:id" element={<FormBuilderPage />} />
        <Route path="forms/:id/submissions" element={<SubmissionsPage />} />
      </Route>

      {/* Public form route */}
      <Route path="/f/:slug" element={<PublicFormPage />} />

      {/* Public results route */}
      <Route path="/results/:key" element={<PublicResultsPage />} />

      {/* Redirect root to admin */}
      <Route path="/" element={<Navigate to="/admin" replace />} />
    </Routes>
  )
}
